import { Button, Stack, Typography } from '@mui/material'
import { Dispatch, memo, SetStateAction } from 'react'
import IvMultiplierButton from './ivMultiplierButton'
import SpotPriceForProfitCalcView from './spotPriceForProfitCalcView'
import TargetDayView from './targetDayView'
import { CustomProfitType } from './PayoffWrapper'
import PnlView from './PnlView'
import { RefreshRounded } from '@mui/icons-material'

export type Props = {
    ivMultiplier: number,
    handleIvMultiplierChange: (newIvMultiplier: number) => void
    setSpotPriceForProfitCalc: Dispatch<SetStateAction<number>>
    price: number,
    numberOfDaysToExpire: number,
    targetDaysFromToday: number,
    numberOfDaysToExpireArray: number[],
    setTargetDaysFromToday: Dispatch<SetStateAction<number>>
    customProfit: CustomProfitType | undefined
    handleResetParams: ()=>void
    priceThreshold: number
    setPriceThreshold: Dispatch<SetStateAction<number>>
    gap?: number
    simulator: boolean
}

const PayoffButtons = ({
    ivMultiplier,
    handleIvMultiplierChange,
    setSpotPriceForProfitCalc,
    price,
    numberOfDaysToExpire,
    targetDaysFromToday,
    setTargetDaysFromToday,
    numberOfDaysToExpireArray,
    customProfit,
    handleResetParams,
    priceThreshold,
    setPriceThreshold,
    gap,
    simulator
}: Props) => {
    return (
        <Stack direction={'row'} sx={{ display: 'flex', flexWrap: 'wrap', py: 1, px: 2, justifyContent: 'space-between', gap: 1, gridArea: 'header' }} alignItems={'center'}>
            <Stack direction={'row'} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', gap: 2 }} alignItems={'center'}>
                <IvMultiplierButton ivMultiplier={ivMultiplier} handleIvMultiplierChange={handleIvMultiplierChange} />
                <SpotPriceForProfitCalcView setSpotPriceForProfitCalc={setSpotPriceForProfitCalc} price={price} priceThreshold={priceThreshold} setPriceThreshold={setPriceThreshold} />
                <TargetDayView
                    numberOfDaysToExpire={numberOfDaysToExpire}
                    targetDaysFromToday={targetDaysFromToday}
                    numberOfDaysToExpireArray={numberOfDaysToExpireArray}
                    setTargetDaysFromToday={setTargetDaysFromToday}
                    simulator={simulator}
                />
                <Button data-event={'Reset strategy builder target params Clicked'} data-event-source={'strategy builder'} variant="text"
                    className="reset-prices"
                    onClick={handleResetParams}
                    startIcon={<RefreshRounded className="reset-prices-icon" />} size={'small'}
                    sx={{ mt: '15px' }}
                >
                    Reset
                </Button>
            </Stack>
            <PnlView profit={customProfit?.profit ?? 0} />
        </Stack>
    )
}

export default memo(PayoffButtons)
